import {
  DOCUMENT_STATUS_FILTER_OPTIONS,
} from '#/modules/imsMgmt/receipts/shared/documentStatus';

export const STOCK_RETURN_STATUS_FILTER_OPTIONS = DOCUMENT_STATUS_FILTER_OPTIONS;

export function canEditStockReturnDraft(status) {
  return status === 'DRAFT';
}

export function canEditStockReturn(status) {
  return canEditStockReturnDraft(status);
}

export function canEditStockReturnRemark(status) {
  return Boolean(status);
}

export function canSubmitStockReturn(status) {
  return status === 'DRAFT';
}

export function canCancelStockReturn(status) {
  return status === 'DRAFT';
}

export function canApproveStockReturn(status) {
  return status === 'SUBMITTED';
}

export function canRejectStockReturn(status) {
  return status === 'SUBMITTED';
}
